module.exports = __webpack_public_path__ + "static/media/Apple iPad Mini Space Grey.19fcca4c.png";